import React from "react";
import Footer from "../Footer";
import Navbar from "../NavBar";
import { Helmet } from "react-helmet";
import SectionHeader from "../shared/SectionHeader";

const TermsAndConditions = () => {
  return (
    <div className="text-gray-800 ">
      <Helmet>
        <title>Terms and Conditions | Storage Sprint</title>
      </Helmet>

      <Navbar />

      <section className="py-28 bg-white ">
        <div className="container mx-auto px-6">
          <SectionHeader
            title="Terms and"
            highlight="Conditions"
            className="mb-12"
          />
          
          <div className="max-w-5xl mx-auto space-y-8">
            <section className="bg-gray-50 rounded-xl p-8">
              <h3 className="text-xl font-bold mb-4 text-gray-800">1. Contractual Relationship</h3>
              <div className="space-y-4 text-gray-600">
                <p>
                  These Terms of Use ("Terms") govern your access to and use of the Storage Sprint platform, including our mobile application, website, content, and services (collectively, the "Services").
                  Storage Sprint ("we," "our," or "us") is a South African-based entity offering storage and logistics solutions.
                </p>
                <p className="font-semibold text-yellow-500">
                  PLEASE READ THESE TERMS CAREFULLY BEFORE ACCESSING OR USING OUR SERVICES.
                </p>
                <p>
                  By accessing or using our Services, you agree to these Terms, forming a contractual relationship with us. If you do not agree, do not use our Services.
                  We reserve the right to modify these Terms or any Services component at any time.
                </p>
              </div>
            </section>

            <section className="bg-gray-50 rounded-xl p-8">
              <h3 className="text-xl font-bold mb-4 text-gray-800">2. Services Overview</h3>
              <p className="text-gray-600">
                Our platform connects users to independent service providers for storage and logistics solutions. We facilitate booking, delivery, and storage services.
                <span className="font-semibold text-gray-800"> Note:</span> Storage Sprint does not directly provide logistics or transport services and is not liable for independent provider actions.
              </p>
            </section>

            <section className="bg-gray-50 rounded-xl p-8">
              <h3 className="text-xl font-bold mb-4 text-gray-800">3. License and Use</h3>
              <p className="text-gray-600">
                We grant a limited, non-exclusive, non-transferable, revocable license for personal, non-commercial use. All rights remain with Storage Sprint or its licensors.
                Unauthorized use, reproduction, or modification of our Services is prohibited.
              </p>
            </section>

            <section className="bg-gray-50 rounded-xl p-8">
              <h3 className="text-xl font-bold mb-4 text-gray-800">4. User Accounts</h3>
              <div className="space-y-4 text-gray-600">
                <p>To use most Services, you must:</p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>Be at least 18 years old</li>
                  <li>Provide accurate information and a valid payment method</li>
                  <li>Keep your account credentials confidential</li>
                </ul>
                <p>You are responsible for activity under your account. Fraudulent behavior may lead to suspension or termination.</p>
              </div>
            </section>

            {/* Continue with other sections in the same pattern */}
            
            <section className="bg-gray-50 rounded-xl p-8">
              <h3 className="text-xl font-bold mb-4 text-gray-800">13. Contact</h3>
              <p className="text-gray-600">
                For questions, email us at <a href="mailto:support@storagesprint.co.za" className="text-yellow-500 hover:underline">support@storagesprint.co.za</a>.
              </p>
            </section>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsAndConditions;